import React, { forwardRef, useImperativeHandle, useState } from "react";
import { Typography, useI18nContext } from "@procore/core-react";
import "./data-count.css";

export interface DataCountRef {
   setCount: (newCount: number) => void;
}

const DataCount = forwardRef<DataCountRef>((props, ref) => {
   const I18n = useI18nContext();
   const [count, setCount] = useState(0);

   // Use useImperativeHandle to expose a function to the parent component that allows it to update the count without re-rendering the component
   useImperativeHandle(ref, () => ({
      setCount: (newCount: number) => {
         setCount(() => newCount);
      },
   }));

   return (
      <Typography intent="small" className="data-count">
         {I18n.t("views.company.workforce_planning.showing") + " " + count}
      </Typography>
   );
});

// Set displayName to improve debugging and to resolve linter warnings
DataCount.displayName = "DataCount";

export default DataCount;
